import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import EntityPicker from 'src/components/Pickers/Picker';
import TagPicker from 'src/components/Pickers/Tag';
import DateInput from 'src/components/Pickers/DateInput';
import TodoRegisterTimeWidget from 'src/components/TodoRegisterTimeWidget';
import TodoEstimatedTime from 'src/components/TodoEstimatedTime';
import SubscriptionTypeUpgrade from 'src/components/SubscriptionTypeUpgrade';
import { dialog } from 'src/boot/mixins.js';
import todoManagement from 'src/mixins/todo-management';
import Todo from 'src/store/models/Todo';
import Project from 'src/store/models/Project';
import TodoList from 'src/store/models/TodoList';
import TagTodo from 'src/store/models/TagTodo';
import Integration from 'src/store/models/Integration';
import { cloneDeep } from 'lodash';
export default {
  mixins: [dialog, todoManagement],
  components: {
    TeDialog: TeDialog,
    EntityPicker: EntityPicker,
    TagPicker: TagPicker,
    DateInput: DateInput,
    TodoEstimatedTime: TodoEstimatedTime,
    TodoRegisterTimeWidget: TodoRegisterTimeWidget,
    SubscriptionTypeUpgrade: SubscriptionTypeUpgrade
  },
  props: {
    todoId: {
      type: Number
    },
    todoListId: {
      type: Number
    },
    projectId: {
      type: Number
    },
    personal: {
      type: [Boolean, Number],
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    lockIntegrationTodos: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this$todoListId;

    return {
      myTodo: {
        name: '',
        description: '',
        priority: 'medium',
        status: 'todo',
        start_date: null,
        due_date: null,
        user_ids: [],
        tag_ids: [],
        is_personal: this.personal ? 1 : 0,
        todo_list_id: (_this$todoListId = this.todoListId) !== null && _this$todoListId !== void 0 ? _this$todoListId : null
      },
      originalTodo: {},
      originalUser: null,
      loading: true
    };
  },
  computed: {
    todo: function todo() {
      return Todo.query().with(['todo_list.project', 'tags', 'integration']).find(this.todoId);
    },
    project: function project() {
      var _this$todo$todo_list;

      if (this.projectId) {
        return Project.find(this.projectId);
      }

      return this.todo ? (_this$todo$todo_list = this.todo.todo_list) === null || _this$todo$todo_list === void 0 ? void 0 : _this$todo$todo_list.project : null;
    },
    canAssignTodo: function canAssignTodo() {
      return this.canDeleteTodo || !this.myTodo.todo_id;
    },
    canDeleteTodo: function canDeleteTodo() {
      return this.todo && this.todo.canDelete(this.me.user_id);
    },
    isTodoLocked: function isTodoLocked() {
      return !!(this.lockIntegrationTodos && this.isIntegrationReadOnly(this.myTodo.integration_code));
    },
    isPersonalTodo: function isPersonalTodo() {
      return this.personal || this.todo && this.todo.is_personal;
    },
    todoListDisableOptions: function todoListDisableOptions() {
      return this.lockIntegrationTodos && this.todo ? ['integration', "integration:".concat(this.project.integration_code)] : [];
    },
    usersFilters: function usersFilters() {
      return {
        project_id: this.projectId,
        active: 1,
        sort_by: 'name',
        direction: 'asc'
      };
    },
    isDirty: function isDirty() {
      var _this = this;

      var dirty = false;
      Object.keys(this.originalTodo).forEach(function (key) {
        if (_this.originalTodo[key] !== _this.myTodo[key]) {
          dirty = true;
        }
      });
      return dirty;
    }
  },
  methods: {
    loadTodo: function loadTodo() {
      var _this2 = this;

      this.loading = true;
      return Todo.api().fetchById(this.todoId).catch(function () {}).finally(function () {
        _this2.loading = false;
      });
    },
    setOriginalTodo: function setOriginalTodo() {
      this.originalTodo = cloneDeep(this.myTodo);
    },
    setLocalTodo: function setLocalTodo() {
      if (!this.isPersonalTodo) {
        this.myTodo = _objectSpread(_objectSpread({}, this.todo), {}, {
          tag_ids: this.todo.tags.map(function (tag) {
            return tag.tag_id;
          }),
          user_ids: this.todo.users.map(function (user) {
            return user.user_id;
          })
        });
      } else {
        this.myTodo = {
          todo_id: this.todo.todo_id,
          integration_code: this.todo.integration_code,
          integration_url: this.todo.integration_url,
          integration: this.todo.integration,
          name: this.todo.name,
          description: this.todo.description,
          status: this.todo.status,
          priority: this.todo.priority,
          due_date: this.todo.due_date,
          estimated_time: this.todo.estimated_time
        };
      }

      this.setOriginalTodo();
    },
    saveTodo: function saveTodo() {
      var _this3 = this;

      this.$refs.todoForm.validate().then(function (result) {
        if (!result) return;

        _this3.showLoading();

        if (_this3.todoId) {
          if (!_this3.isPersonalTodo) {
            // update todo in local store in case of changing todo_list or status
            Todo.moveToIndex(_this3.myTodo.todo_id, _this3.myTodo);
          } // If the todo list exists and is not editable, only update the estimated time


          var updateData = _objectSpread({}, _this3.myTodo);

          if (_this3.todo.todo_list && !_this3.todo.todo_list.isEditable()) {
            updateData = {
              estimated_time: _this3.myTodo.estimated_time
            };
          }

          return Todo.api().update(_this3.myTodo.todo_id, updateData, true).then(function (response) {
            var todoData = response.response.data;
            TagTodo.delete(function (tagTodo) {
              return tagTodo.todo_id === todoData.todo_id && !todoData.tags.map(function (g) {
                return g.tag_id;
              }).includes(tagTodo.tag_id);
            });

            _this3.setOriginalTodo();

            _this3.$root.$emit('refresh-todos');

            _this3.hide();
          }).catch(function () {}).finally(function () {
            _this3.hideLoading();
          });
        } else {
          return Todo.api().store(_this3.myTodo).then(function (result) {
            if (!_this3.isPersonalTodo) {
              var newTodo = result.response.data;
              var todoList = TodoList.query().with('todos').find(newTodo.todo_list_id);
              todoList.increaseTodosCount(newTodo.status === 'completed');
              todoList.todos.forEach(function (todo) {
                if (todo.todo_id === newTodo.todo_id) return;
                Todo.update({
                  where: todo.todo_id,
                  data: {
                    index: todo.index + 1
                  }
                });
              });
            }

            _this3.$root.$emit('refresh-todos');

            _this3.hide();
          }).catch(function () {}).finally(function () {
            _this3.hideLoading();
          });
        }
      });
    },
    deleteTodo: function deleteTodo() {
      var _this4 = this;

      this.showLoading('');
      return Todo.api().destroy(this.todoId).then(function () {
        _this4.$q.notify({
          type: 'positive',
          message: _this4.$t('components.todoDialog.deleted_task')
        });

        _this4.$root.$emit('refresh-todos');
      }).catch(function () {}).finally(function () {
        _this4.hideLoading();

        _this4.hide();
      });
    },
    isIntegrationReadOnly: function isIntegrationReadOnly(integrationCode) {
      if (!integrationCode) {
        return false;
      }

      return !Integration.query().all().filter(function (integration) {
        return integration.features.reduce(function (acc, feature) {
          return acc || feature === 'TasksWrite';
        }, false);
      }).map(function (integration) {
        return integration.integration_code;
      }).includes(integrationCode);
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    if (this.todoId) {
      if (this.todo) {
        this.setLocalTodo();
      }

      this.loadTodo().then(function (result) {
        _this5.setLocalTodo();
      });
    } else {
      this.loading = false;
    }
  }
};